import { RelativeUrl } from '../../../../app/shared/Url';
import { PricelistListingItemTranslation } from '../../../localization/ModuleTranslation';
import { CustomerPricelistData } from '../../../model';
import { ModuleRoutes } from '../../../ModuleRoutes';

export default class PricelistListingItemState {
  public readonly detailsRouteUrl: RelativeUrl;

  public constructor(
    public readonly data: CustomerPricelistData,
    private readonly routes: ModuleRoutes,
    public readonly locale: string,
    public readonly translation: PricelistListingItemTranslation,
  ) {
    this.detailsRouteUrl = this.routes.pricelistDetails(data.id);
  }
}
